import { AuditorSimulationService } from '@anecdotes/auth-core';
import { inject, Injectable } from '@angular/core';

@Injectable()
export class AuditorSimulationGuard {
  private readonly auditorSimulationService = inject(AuditorSimulationService);

  canActivateChild(): boolean {
    this.auditorSimulationService.changeAppIfSessionKeyExists();

    return true;
  }
}
